import { Component, Input, OnInit } from '@angular/core';
import { SharedDateService } from '../../../../../../../shared/services/shared-date.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../../../../../shared/services/auth.service';
import { GroupRole } from '../../../../../../../shared/models/group-role';

@Component({
  selector: 'app-scenario',
  templateUrl: './scenario.component.html',
  styleUrls: ['./scenario.component.scss']
})
export class ScenarioComponent implements OnInit {
  @Input() selectedDate: Date | null = null;
  @Input() sidebarIsOpen: boolean = false;
  selectedScenario: string | null = null;
  scenarios: { key: string, value: string }[] = [];
  userGroups: GroupRole[] = [];
  isPremium: boolean = false;

  constructor(private sharedScenarioService: SharedDateService, private translate: TranslateService, private authService: AuthService) {}

  ngOnInit(): void {
    this.sharedScenarioService.selectedScenario$.subscribe(scenario => {
      this.selectedScenario = scenario;
    });
    this.authService.getUserInfo().subscribe( res => {
      if(res?.groupeUtilisateur)
      this.userGroups = res?.groupeUtilisateur;
      if(this.userGroups)
      this.isPremium = this.userGroups.some(groupRole => groupRole.groupe.nom !== "Public");
      this.loadScenarios();
    });
    this.loadScenarios();
    this.translate.onLangChange.subscribe(() => {
      this.loadScenarios();
    });
  }

  loadScenarios(): void {
    if(this.isPremium){
      this.scenarios = [
        { key: this.translate.instant('MAP.SCENARIO.HUMID_10_YEARS'), value: 'Prévision 10 ans humide' },
        { key: this.translate.instant('MAP.SCENARIO.HUMID_5_YEARS'), value: 'Prévision 5 ans humide' },
        { key: this.translate.instant('MAP.SCENARIO.MEDIAN_RAIN'), value: 'Prévision pluie médiane' },
        { key: this.translate.instant('MAP.SCENARIO.DRY_5_YEARS'), value: 'Prévision 5 ans sec' },
        { key: this.translate.instant('MAP.SCENARIO.DRY_10_YEARS'), value: 'Prévision 10 ans sec' },
        { key: this.translate.instant('MAP.SCENARIO.NO_RAIN'), value: 'Prévision sans pluie' }
      ];
    } else {
      this.scenarios = [
        { key: this.translate.instant('MAP.SCENARIO.ALT_HUMID_RAIN'), value: 'Prévision 10 ans humide' },
        { key: this.translate.instant('MAP.SCENARIO.ALT_MEDIAN_RAIN'), value: 'Prévision pluie médiane' },
        { key: this.translate.instant('MAP.SCENARIO.ALT_DRY_RAIN'), value: 'Prévision sans pluie' }
      ];
    }
  }

  onScenarioChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    let scenario = target.value;
    if(scenario.indexOf(":")!=0) {
      scenario = scenario.split(": ")[1]
    }

    if (scenario) {
      this.selectedScenario = scenario;
      console.log(scenario)
      this.sharedScenarioService.updateSelectedScenario(scenario);
    }
  }

  isDateInFuture(): boolean {
    if (this.selectedDate) {
      const today = new Date();
      return this.selectedDate > today;
    }
    return false;
  }
}
